import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import DeviceActivityList from './DeviceActivityList.jsx';
import { useSetModalTitle } from '../../../hooks/modal/useSetModalTitle.ts';

interface DeviceActivityRouteParams {
  id: string;
}

export const DeviceActivityRoute: FC = () => {
  useSetModalTitle('Activity');

  const { id: deviceId } = useParams<DeviceActivityRouteParams>();
  return <DeviceActivityList deviceId={deviceId} />;
};
